import selectIcon from "./selecticon.png"
import { Box } from "theme-ui"
import { IDeviceTreeGroupElement, IDeviceGroup, IDeviceTree } from "@types"
import { useEffect, useState } from "react"
import { compareDeviceGroupElements } from "utils/assert"
interface props {
 server: IDeviceTree
 handleOpenServerList: (_server: number) => void
 openServerList: number[]
 selectedDeviceTreeGroupElements: IDeviceTreeGroupElement[]
 setSelectedDeviceTreeGroupElements: (..._arg: any[]) => void
}
export const SideBarCategory = ({
 server,
 handleOpenServerList,
 openServerList,
 selectedDeviceTreeGroupElements,
 setSelectedDeviceTreeGroupElements,
}: props) => {
 const [checkAnyDeviceIsSelectedInThisServer, setCheckAnyDeviceIsSelectedInThisServer] =
  useState<boolean>(false)
 const allDeviceTreeGroupElementsOfThisServer: IDeviceTreeGroupElement[] = server.device_groups
  .map((deviceGroup: IDeviceGroup) => {
   return deviceGroup.devices.map((device: IDeviceTreeGroupElement) => device)
  })
  .flat()
 const allDeviceTreeGroupElementsOfThisServerInSelectedList =
  selectedDeviceTreeGroupElements.filter(
   (device: IDeviceTreeGroupElement) =>
    !!allDeviceTreeGroupElementsOfThisServer.find(
     (deviceObj: IDeviceTreeGroupElement) =>
      device.device_id === deviceObj.device_id &&
      device.group_id === deviceObj.group_id &&
      device.server_id === deviceObj.server_id,
    ),
  )
 const isAllDeviceTreeElementsSelected: boolean = compareDeviceGroupElements(
  allDeviceTreeGroupElementsOfThisServerInSelectedList,
  allDeviceTreeGroupElementsOfThisServer,
 )
 useEffect(() => {
  if (isAllDeviceTreeElementsSelected) {
   setCheckAnyDeviceIsSelectedInThisServer(false)
  } else {
   let helperState = false
   allDeviceTreeGroupElementsOfThisServer.forEach((device: IDeviceTreeGroupElement) => {
    if (
     !!selectedDeviceTreeGroupElements.find(
      (deviceObj: IDeviceTreeGroupElement) =>
       deviceObj.device_id === device.device_id &&
       deviceObj.group_id === device.group_id &&
       deviceObj.server_id === device.server_id,
     )
    ) {
     helperState = true
    }
   })
   if (helperState) {
    setCheckAnyDeviceIsSelectedInThisServer(true)
   } else {
    setCheckAnyDeviceIsSelectedInThisServer(false)
   }
  }
  // eslint-disable-next-line
 }, [selectedDeviceTreeGroupElements])

 // Toggle select server
 const toggleSelectServer = () => {
  if (isAllDeviceTreeElementsSelected) {
   let duplicateSelectedDeviceTreeGroupElements = [...selectedDeviceTreeGroupElements]
   allDeviceTreeGroupElementsOfThisServer.forEach((deviceObj: IDeviceTreeGroupElement) => {
    duplicateSelectedDeviceTreeGroupElements = duplicateSelectedDeviceTreeGroupElements.filter(
     (device: IDeviceTreeGroupElement) =>
      device.device_id !== deviceObj.device_id || device.group_id !== deviceObj.group_id || device.server_id !== deviceObj.server_id,
    )
   })
   setSelectedDeviceTreeGroupElements([...duplicateSelectedDeviceTreeGroupElements])
  } else {
   setSelectedDeviceTreeGroupElements([
    ...selectedDeviceTreeGroupElements,
    ...allDeviceTreeGroupElementsOfThisServer,
   ])
  }
 }

 const selectOnlyThisServerDevices = () => {
  setSelectedDeviceTreeGroupElements([...allDeviceTreeGroupElementsOfThisServer])
 }
 return (
  <div className={"flex gap-2 py-2 rounded pl-4 w-11/12 mx-auto my-2 bg-light-yellow"}>
   <div
    onClick={() => {
     handleOpenServerList(server?.server_id)
    }}
    className="bg-golden h-6 w-6 rounded border-yellow border flex justify-center items-center cursor-pointer"
   >
    <img
     className={` ${openServerList.includes(server.server_id) ? "rotate-360" : "rotate-180"}`}
     src={selectIcon}
     alt="selectIcon"
     loading="lazy"
    />
   </div>
   <Box color="text">
    {checkAnyDeviceIsSelectedInThisServer ? (
     <div className="flex gap-2">
      <span
       className="bg-golden h-6 w-6 rounded border-yellow border flex justify-center items-center cursor-pointer"
       onClick={() => toggleSelectServer()}
      >
       <div className="w-[10px] h-[2px] bg-black"></div>
      </span>
      <label className="font-semibold cursor-pointer font-sm Jakarta-font">
       {server.server_name}
      </label>
     </div>
    ) : (
     <div className="flex gap-2">
      <span
       className="bg-golden h-6 w-6 rounded border-yellow border flex justify-center items-center cursor-pointer"
       onClick={() => toggleSelectServer()}
      >
       {isAllDeviceTreeElementsSelected && <span>✔</span>}
      </span>
      <label
       className="font-semibold cursor-pointer font-sm Jakarta-font"
       onClick={() => {
        selectOnlyThisServerDevices()
       }}
      >
       {server.server_name}
      </label>
     </div>
    )}
   </Box>
  </div>
 )
}
